import { render, staticRenderFns } from "./Keyword.vue?vue&type=template&id=4c6e30d1&scoped=true"
import script from "./Keyword.vue?vue&type=script&lang=js"
export * from "./Keyword.vue?vue&type=script&lang=js"
import style0 from "./Keyword.vue?vue&type=style&index=0&id=4c6e30d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6e30d1",
  null
  
)

export default component.exports